<template>
  <a-modal
    :visible="visible"
    centered
    title="Update License Count"
    :closable="!loading"
    :maskClosable="!loading"
    @cancel="handleCancel"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      layout="vertical"
    >
      <a-form-item label="Total Licenses" name="total_licenses">
        <a-input-number
          v-model:value="form.total_licenses"
          :min="assigned"
          :max="10000"
          style="width: 100%"
          placeholder="Enter total license count"
        />
      </a-form-item>
      <a-alert
        v-if="form.total_licenses < assigned"
        type="error"
        class="mb-3"
        message="Invalid license count"
        :description="`Cannot set total licenses below the currently assigned count (${assigned}). Please revoke some licenses first.`"
        show-icon
      />
      <div class="info-section">
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Current Total:</span>
          <strong>{{ currentTotal }}</strong>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Currently Assigned:</span>
          <strong>{{ assigned }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span class="text-muted">New Available:</span>
          <strong :class="{ 'text-success': newAvailable > 0, 'text-danger': newAvailable <= 0 }">
            {{ newAvailable }}
          </strong>
        </div>
      </div>
    </a-form>
    <template #footer>
      <a-button @click="handleCancel" :disabled="loading">Cancel</a-button>
      <a-button
        type="primary"
        :loading="loading"
        :disabled="form.total_licenses < assigned"
        @click="handleSubmit"
      >
        Update
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'UpdateLicenseModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentTotal: {
      type: Number,
      default: 0,
    },
    assigned: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible', 'submit'],
  data() {
    return {
      form: {
        total_licenses: this.currentTotal,
      },
      rules: {
        total_licenses: [
          { required: true, message: 'Please enter license count', trigger: 'blur' },
          { type: 'number', min: 0, message: 'License count must be a positive number', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    newAvailable() {
      return (this.form.total_licenses || 0) - this.assigned;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.form.total_licenses = this.currentTotal;
      }
    },
    currentTotal(newVal) {
      this.form.total_licenses = newVal;
    },
  },
  methods: {
    handleCancel() {
      if (!this.loading) {
        this.$emit('update:visible', false);
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        if (this.form.total_licenses >= this.assigned) {
          this.$emit('submit', this.form.total_licenses);
        }
      } catch (error) {
        console.log('Validation failed:', error);
      }
    },
  },
};
</script>

<style scoped>
.info-section {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 6px;
  margin-top: 16px;
}
</style>
